import { KnifeIcon } from './KnifeIcon';

/**
 * author: Augustin Ursu
 * id AF35DB46-1B52-4721-8475-F3CD107325B4
 * name knife
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/knife.svg
 * tags
 */
export const SilverwareKnifeIcon = KnifeIcon;
export default SilverwareKnifeIcon